import {
  shape,
  string
} from 'prop-types';

import OrderInfo from './OrderInfo';

export default shape({
  invoiceId: string.isRequired,
  order: OrderInfo.isRequired
});



// WEBPACK FOOTER //
// ./src/utils/shapes/Transaction.js